<template>
  <div>
    <div class="tab-title">我的相册</div>
    <ProfessionForm :mold="profession" />
    <div class="edit-album-container">
      <EditAlbum />
    </div>
    <div class="feed-list-container" v-loading="feedShade">
      <AlbumItem
        v-for="feed in feedList"
        :key="feed.id"
        :feed="feed"
        :page="feedPage"
      />
      <p class="no-feed" v-if="feedList.length == 0">{{ noFeedText }}</p>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="totalPage"
        prev-text="上一页"
        next-text="下一页"
        hide-on-single-page
        ref="pagination"
        @current-change="curtListPageClick"
      >
      </el-pagination>
      <!-- @prev-click="prevtListPageClick" @next-click="nextListPageClick" -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../utils/apiMap";
import ProfessionForm from "../../components/user/storeroom/profession-form";
import EditAlbum from "../../components/user/edit-album";
import AlbumItem from "../../components/user/storeroom/album-item";
export default {
  name: "user-album",
  data() {
    return {
      profession: {
        name: "专业照相",
        title: "专业照相申请",
        type: 2,
      },
      feedShade: true,
      feedPage: 1,
      feedList: [],
      feedTotal: 0,
      noFeedText: "",
    };
  },
  components: {
    ProfessionForm,
    EditAlbum,
    AlbumItem,
  },
  computed: {
    ...mapGetters(["userCenterSign"]),
    totalPage() {
      return this.feedTotal;
    },
  },
  mounted() {
    this.feedPage = this.userCenterSign.albumPage || 1;
    this.getAlbumList(this.feedPage);
    this.$bus.$on("reload-album-list", this.reloadAlbumList);
  },
  methods: {
    getAlbumList(page) {
      let _this = this;
      _this.getListBtn = false;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["albumList"]["method"],
          url: apiMap["albumList"]["url"],
          params: {
            token: loginUser.token,
            start: page,
            count: 10,
            orderField: "created_at",
            order: "desc",
            type: 1,
          },
        })
        .then(function (response) {
          _this.feedShade = false;
          if (response.data.result.statusCode == 1) {
            _this.feedList = response.data.result.data;
            _this.feedTotal = response.data.result.count;
            _this.$refs.pagination.internalCurrentPage = page;
          } else {
            _this.noFeedText = "暂无相册";
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getAlbumList(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getAlbumList(newPage);
    },
    nextListPageClick(newPage) {
      this.feedPage = newPage;
      this.getAlbumList(newPage);
    },
    reloadAlbumList() {
      this.feedShade = true;
      this.feedTotal = 0;
      this.feedList = [];
      this.getAlbumList(this.feedPage);
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.edit-album-container {
  width: 840px;
  padding: 10px 15px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background-color: #fff;
}

.feed-list-container {
  min-height: 120px;
}

.no-feed {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper {
  margin-bottom: 15px;
  padding: 5px 0;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper:empty {
  padding: 0;
}
</style>